export default "__VITE_ASSET__BNnbetJm__"